// extracted by mini-css-extract-plugin
export var attachment = "_r7-a";
export var emailContainer = "_r7-4";
export var emailContentPaddedContainer = "_r7-b";
export var emailHeader = "_r7-6";
export var emailIframe = "_r7-3";
export var emailInfoIcon = "_r7-9";
export var emailShortenedSummary = "_r7-e";
export var infoDropdown = "_r7-0";
export var infoRowBoundedContent = "_r7-d";
export var internal = "_r7-5";
export var merchant = "_r7-8";
export var messageInputContainer = "_r7-h";
export var normal = "_r7-7";
export var replyCard = "_r7-f";
export var subtleButton = "_r7-1";
export var subtleButtonIconContainer = "_r7-2";
export var toggleViewRepliesButton = "_r7-c";
export var wrappingText = "_r7-g";